/* eslint-disable space-before-function-paren */
const service = require('../../../assets/js/request')
const env = process.env

class training {
  static getColumnId(target) {
    console.log(service)
    service.request({
      method: 'POST',
      url: 'getArtivleDetails',
      params: {
        id: target.id
      }
    }).then(res => {
      if (res.code === '2001') {
        if (res.data.cover_img !== '') {
          res.data.cover_img = env.IMG_URL + res.data.list[0].cover_img
        } else {
          res.data.cover_img = '/static/defaultBg.png'
        }
        target.con = res.data
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }

  static getArtivleList(target, cateid) {
    service.request({
      method: 'POST',
      url: 'getArtivleList',
      params: {
        cate_id: cateid,
        isSpecial: 1
      }
    }).then(res => {
      if (res.code === '2001') {
        if (res.data.list.length > 0) {
          if (res.data.list[0].cover_img !== '') {
            res.data.list[0].cover_img = env.IMG_URL + res.data.list[0].cover_img
          } else {
            res.data.list[0].cover_img = '/static/defaultBg.png'
          }
          target.con = res.data.list[0]
        }
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }
}

export default training



// WEBPACK FOOTER //
// ./src/components/index/training/training.js